import { CircularProgress, Typography, styled } from '@mui/material';

export const StyledCircularProgress = styled(CircularProgress)({
  placeSelf: 'center',
});

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  display: 'flex',
  pt: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));
